// @ts-nocheck
// TypeScript is ignoring this file. If you are editing this file you must fix the type issues.

import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Table } from '../Table';
import { INVOICES_TABLE_COLUMNS, INVOICE_HUB_TABLES, INVOICE_HUB_AUTOMATION_IDS } from '../../consts/consts';
import { useStore } from '../../../../../store';
import { buildQueryString, mapDataForInvoicesTable, scrollWebappToTop } from '../../utils';
import { useFetchInvoices } from '../../hooks/useFetchInvoices';
import { InvoiceHubContext } from '../../contexts/InvoiceHubContext';
import { HUB_MODALS } from '../InvoiceHubModals';

export const PaidInvoicesTable = () => {
  const paidPageNumber = useStore(state => state.paidPageNumber);
  const setPaidPageNumber = useStore(state => state.setPaidPageNumber);
  const paidInvoices = useStore(state => state.paidInvoices);
  const setPaidInvoices = useStore(state => state.setPaidInvoices);
  const setError = useStore(state => state.setError);
  const setActiveModal = useStore(state => state.setActiveModal);
  const [hasMoreToFetch, setHasMoreToFetch] = useState<boolean>(true);
  const { t } = useTranslation();
  const { refetch: fetchInvoices, isFetching } = useFetchInvoices({
    onSuccess: async (data: any) => {
      if (data?.invoices?.length === 0) {
        setHasMoreToFetch(false);
      } else {
        setPaidInvoices(data.invoices, paidPageNumber > 1);
      }
    },
    onError: (error: any) => {
      setError(error);
      setActiveModal(HUB_MODALS.ERROR);
    },
    queryString: buildQueryString(INVOICE_HUB_TABLES.PAID.name, paidPageNumber),
    tableName: INVOICE_HUB_TABLES.PAID.name,
  });

  useEffect(() => {
    setTimeout(() => {
      scrollWebappToTop();
    }, 0);
  }, []);

  useEffect(() => {
    fetchInvoices();
  }, [paidPageNumber]);

  const contextValue = useMemo(() => ({
    fetchMoreInvoices: () => {
      if (hasMoreToFetch) {
        setPaidPageNumber(paidPageNumber + 1);
      }
    },
  }), [paidPageNumber]);
  const paidInvoiceRows = useMemo(() => mapDataForInvoicesTable(INVOICE_HUB_TABLES.PAID.name, paidInvoices), [paidInvoices]);

  return (
    <InvoiceHubContext.Provider value={contextValue}>
      <Table
        name={INVOICE_HUB_TABLES.PAID.name}
        title={`${t(INVOICE_HUB_TABLES.PAID.title)} (${paidInvoiceRows?.length || 0})`}
        columns={INVOICES_TABLE_COLUMNS}
        data={paidInvoiceRows}
        testId={INVOICE_HUB_AUTOMATION_IDS.HUB_TABLE_PAID}
        isLoading={isFetching && paidPageNumber === 1}
      />
    </InvoiceHubContext.Provider>
  );
};
